export const PATH = {
  HOME: '/',
  LOGIN_BY_APIKEY: '/loginByApikey',
  TAX_LOOKUP_MST: '/tax/tra-cuu-mst',
  TAX_LOOKUP_OBLIGATION: '/tax/tra-cuu-nghia-vu-thue',
  TAX_LOOKUP_FINALIZATION: '/tax/tra-cuu-quyet-toan',
  TAX_LOOKUP_HKD_STATUS: '/tax/tra-cuu-tinh-trang-hoat-dong-hkd',
  TAX_LOOKUP_DECLARATION_STATUS: '/tax/tinh-trang-nop-to-khai',
  TAX_LOOKUP_REFUND: '/tax/tra-cuu-hoan-thue',
  TAX_LOOKUP_EXIT_BAN: '/tax/tra-cuu-tam-hoan-xuat-canh',
  TAX_NOTIFICATION: '/tax/thong-bao',
  TAX_NOTIFICATION_DETAIL: '/tax/thong-bao/:id',
  IFRAME_VIEW: '/page',
  MAINTENANCE: '/maintenance',
  PROFILE: '/profile',
  PERSONAL_INFO: '/profile/info',
  CHANGE_PASSWORD: '/profile/change-password',
  COOPERATION: '/profile/cooperation',
  CUSTOMER_SUPPORT: '/profile/customer-support',
  FEEDBACK: '/profile/feedback',
  TERM: '/profile/terms',
  PRIVATE_INFORMATION_POLICY: '/profile/terms/private-information-policy',
  PAYMENT_POLICY: '/profile/terms/payment-policy',
  GENERAL_TERM: '/profile/terms/general-term'
}